exports.colors = {
  onyx: "#0c120c",
  blue: "#628598",
  green: "#107d00",
  yellow: "#ee9d00",
  purple: "#701788",
  "dark-gray": "#545454",
  "mid-gray": "#828282",
  "placeholder-gray": "#a6a6a6",
  "disabled-gray": "#f2f2f2",
  red: {
    lighter: "#ff8387",
    light: "#e84d52",
    default: "#b3282d",
    dark: "#7f0b0f"
  },
  lightgray: {
    default: "#c2c2c2",
    lighter: "#dedede",
    lightest: "#eeeeee"
  }
};
